import "./Verify.css";

import {Fragment, useContext, useEffect} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import { AppStore } from "app/model/AppStore";
import { RmdLogo } from "shared/ui/RmdLogo/RmdLogo";
import { pagePaths } from "shared/config/pagePaths";
import { useScreenMode } from "app/lib/useScreenMode";

import { RmdPage } from "../RmdPage";
import {useTranslation} from "react-i18next";

export const Verify = () => {
    const { t } = useTranslation();
    const { authProcess: { authStore, notificationStore, ...rest } } = AppStore.getShared();
    const isMobile = useScreenMode();
    const location = useLocation();
    const navigate = useNavigate();
    const { appMediaStore, authProcess } = AppStore.getShared();

    const verifyToken = location.search.slice(7);

    if (verifyToken) {
        localStorage.setItem("verifyToken", verifyToken);
    }

    const verifyAccount = async () => {
        const result = await authProcess.registerStore.verifyAccount();

        if (result) {
            navigate(pagePaths.HOME_ROUTE);
        }
    }

    useEffect(() => {
        verifyAccount();
    }, [])

    return (
        <Fragment>
            <RmdPage
                headerLeft={""}
                headerMiddle={
                    <RmdLogo isMobile={isMobile} onClick={() => navigate(pagePaths.HOME_ROUTE)} />
                }
                body={
                    <main className="password-reset-page">
                        { t("verification") }
                    </main>
                }
            />
            <Outlet />
        </Fragment>
    );
}